/* eslint-disable @typescript-eslint/no-explicit-any */
import WalletConnectQRCodeModal from "@walletconnect/qrcode-modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import * as Web3Lib from "web3";
const Web3 = (Web3Lib as any).default || Web3Lib;
type Web3Instance = InstanceType<typeof Web3>;

let web3: Web3Instance | null = null;

interface Window {
  ethereum: any;
  web3: any;
}
declare const window: Window;

// BSC Testnet public RPCs — rotate on failure to avoid rate-limit errors
const BSC_TESTNET_RPCS = [
  "https://data-seed-prebsc-1-s1.binance.org:8545/",
  "https://data-seed-prebsc-2-s1.binance.org:8545/",
  "https://data-seed-prebsc-1-s2.binance.org:8545/",
  "https://data-seed-prebsc-2-s2.binance.org:8545/",
];
let rpcIndex = 0;
export const getNextRPC = (): string =>
  BSC_TESTNET_RPCS[rpcIndex++ % BSC_TESTNET_RPCS.length];

const walletConnectProvider = new WalletConnectProvider({
  rpc: {
    // 0x38: 'https://bsc-dataseed.binance.org/', // BSC Mainnet chainId - 56
    0x61: BSC_TESTNET_RPCS[0], // BSC Testnet chainId - 97
  },
  // chainId: 0x38, // BSC Mainnet
  chainId: 0x61, // BSC Testnet
  qrcode: false,
});

// // services.js – helper
// export const getWeb3Accounts = async (): Promise<Web3Accounts> => {
//   const web3 = new Web3(window.ethereum);
//   await window.ethereum.request({ method: "eth_requestAccounts" });
//   const accounts = await web3.eth.getAccounts();
//   return { web3, account: accounts[0] };
// };

const metamaskConnectInit = (): Promise<boolean> => {
  // Check if Web3 has been injected by the browser (Mist/MetaMask/Coinbase).
  return new Promise((resolve, reject) => {
    if (typeof window.web3 !== "undefined") {
      // Use Mist/MetaMask's provider.
      web3 = new Web3(window.web3.currentProvider);
      localStorage.setItem("walletConnect", "0");
      resolve(true);
    } else if (typeof window.ethereum !== "undefined") {
      // Check for ethereum provider (MetaMask, Coinbase Wallet, etc.)
      web3 = new Web3(window.ethereum);
      localStorage.setItem("walletConnect", "0");
      resolve(true);
    } else {
      // Handle the case where the user doesn't have web3. Probably
      // show them a message telling them to install Metamask in
      // order to use the app.
      web3 = new Web3(
        new Web3.providers.HttpProvider(getNextRPC())
      );
      reject(false);
    }
  });
};

const walletConnectInit = (): Promise<boolean> => {
  // Check if WalleConnect has been connected by the website
  return new Promise((resolve, reject) => {
    if (!walletConnectProvider.connector.connected) {
      metamaskConnectInit();
      reject(false);
    } else {
      // Use WalletConnect provider.
      walletConnectProvider.enable();
      // Fix the type issue with a more direct cast approach
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      web3 = new Web3(walletConnectProvider as any);
      resolve(true);
    }
  });
};

const walletConnectModalInit = (): Promise<boolean> => {
  return new Promise((resolve) => {
    localStorage.setItem("walletConnect", "1");
    walletConnectProvider.enable();
    // Fix the type issue with a more direct cast approach
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    web3 = new Web3(walletConnectProvider as any);

    // Wallet Connect Provider Events
    walletConnectProvider.connector.on(
      "display_uri",
      (err: Error | null, payload: { params: string[] }) => {
        const uri = payload.params[0];
        // Fix the argument count issue by providing the optional second parameter
        WalletConnectQRCodeModal.open(uri, () => {
          console.log("QR Code Modal opened");
        });
      }
    );

    walletConnectProvider.on("connect", () => {
      WalletConnectQRCodeModal.close(); // close the QR scanner modal
    });

    walletConnectProvider.on("disconnect", () => {
      // console.log('wallet connect disconnected', code, reason);
      localStorage.clear();
    });

    resolve(true);
  });
};

// Function to initialize Coinbase Wallet specifically
const coinbaseWalletInit = (): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    if (
      typeof window.ethereum !== "undefined" &&
      window.ethereum.isCoinbaseWallet
    ) {
      web3 = new Web3(window.ethereum);
      localStorage.setItem("walletConnect", "0");
      resolve(true);
    } else {
      reject(false);
    }
  });
};

// Function to refresh web3 instance after network switch
const refreshWeb3Instance = (): void => {
  if (typeof window.ethereum !== "undefined") {
    // Create a new web3 instance with the current ethereum provider
    web3 = new Web3(window.ethereum);
  } else if (typeof window.web3 !== "undefined") {
    // Fallback to window.web3
    web3 = new Web3(window.web3.currentProvider);
  }
};

// Function to force web3 instance to use BSC Testnet
const forceBSCTestnetWeb3 = (): void => {
  web3 = new Web3(new Web3.providers.HttpProvider(getNextRPC()));
};

// Initialize web3 based on stored connection type
if (!web3) {
  const walletConnectValue = localStorage.getItem("walletConnect");
  if (walletConnectValue && Number(walletConnectValue) > 0) {
    walletConnectInit();
  } else {
    metamaskConnectInit();
  }
}

export {
  metamaskConnectInit,
  walletConnectInit,
  walletConnectModalInit,
  coinbaseWalletInit,
  refreshWeb3Instance,
  forceBSCTestnetWeb3,
  walletConnectProvider,
  web3,
};
